export default function () {
  if (this.$route.name === 'EditCoupon') {
    this.loadCoupon()
  }
}
